export const enumHeaderTheme = {
    RED : "red",
    BLUE : "blue",
    WHITE : "white",
    IRIS: "iris"
}